export default function getUploadTypeDescription(userGroup = '') {
  switch (userGroup) {
    case 'b2b':
      return 'de envíos de B2B';
    case 'ollas':
      return 'de envíos de ollas GM';
    case 'sat':
      return 'de envíos de SAT Reparaciones';
    default:
      return 'adecuados para este grupo';
  }
}
